import React, {useState} from "react"
import { StaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import PrivacyPolicyPage from "../pages/privacypolicy"
import ArticlesComponent from "../components/articles"

import "../assets/css/main.css";
import "../assets/css/inputs.css";

import Questao from "../components/questao"
import Questionario from "../components/questionario"

const IndexPage = () => { 
  var setMain = (data) =>{
    if(!questionarioatual){
      return (
      <>

        <h1 className="title">{data.strapiMainPage.Title}</h1>
        <h2 className="subtitle">{data.strapiMainPage.Description}</h2>
        <div className="questionarios">
      
          {data.allStrapiQuestionario.nodes.map(x => {
            return(
            <Questionario questionario={x} escolheQuestao={setQuestao} ></Questionario>
          )})}
        </div>
    </>
      );
    }
    else
    {
      let q = data.allStrapiQuestionario.nodes.find(x => x.id == questionarioatual);
      return (<Questao  questoes={q.Perguntas} icone={q.Icon.publicURL} iconeBusiness={data.strapiMainPage.TopLogo.publicURL} contactoTitulo={data.strapiMainPage.ResumoContactoTitulo} contactoDescricao={data.strapiMainPage.ResumoContactoTexto} service={q.ServiceName}></Questao>)
    }
    };
    
  const [questionarioatual, setquestionarioatual] = useState("");
  var setQuestao = (questionario) => {setquestionarioatual(questionario.id)}
  return (
  <Layout>
    <StaticQuery
      query={graphql`
      query {
        strapiMainPage {
          id
          Title
          Description
          TopLogo {
            publicURL
          }
          BackgroundImage {
            publicURL
          }
          ResumoContactoTexto
          ResumoContactoTitulo
        }
        allStrapiQuestionario {
          nodes {
            Name
            id
            Perguntas {
              Title
              id
              Respostas {
                Title
                Cost
                id
              }
            }
            Icon {
              publicURL
            }
            ServiceName
          }
        }
      }
      `}

      render={data => {
        return(<>
          {setMain(data)}
          </>
        )}}
        />
  </Layout>
)}

export default IndexPage
